import { LogTypesEnum } from '../../enums';

interface IExtraLogsSchema {
    reason?: string;
    previousScheduledStart?: string;
    updatedScheduledStart?: string;
    stepName?: string;
    previousPlannedAt?: string;
    updatedPlannedAt?: string;
    licensePlate?: string;
    previousLicensePlate?: string;
    updatedLicensePlate?: string;
    driverName?: string;
    previousDriverName?: string;
    updatedDriverName?: string;
    latitude?: string;
    longitude?: string;
    previousLocation?: string;
    updatedLocation?: string;
    checkpointIndex?: string;
    locationName?: string;
    missingZoneTypes?: string;
    tripCodes?: string;
}

export interface ILogSchema {
    id?: string;
    trip: string;
    message: string;
    datetime?: string;
    source?: string;
    createdBy?: string | null;
    createdAt?: string | null;
    type?: LogTypesEnum;
    seenBy?: string[];
    seenByCurrent?: boolean;
    extra?: IExtraLogsSchema;
}
